/**
 * @generated SignedSource<<8667cdb93d7444d7f3275d433d5687eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespDesignsComponents_shippingFilters$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedPersonalizedFilterToast_shippingFilters">;
  readonly " $fragmentType": "SbRespDesignsComponents_shippingFilters";
}>;
export type SbRespDesignsComponents_shippingFilters$key = ReadonlyArray<{
  readonly " $data"?: SbRespDesignsComponents_shippingFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespDesignsComponents_shippingFilters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbRespDesignsComponents_shippingFilters",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedPersonalizedFilterToast_shippingFilters"
    }
  ],
  "type": "ShippingFilterType",
  "abstractKey": null
};

(node as any).hash = "640a05344ffb2cc246baa206c17e0031";

export default node;
